import { Input } from '@angular/core';
import { VrInputField } from '../../../shared/vr-element-field/vr-input-field';

export abstract class VrInput extends VrInputField {
  @Input() type = 'text';
  @Input() imask!: any;
  @Input() unmask: boolean | string = true;

  constructor() {
    super();
  }
}
